import { IBrandCategory } from "../../../Models/IBrandCategory";
import {
    CategoryActionType,
    GET_ALL_CATEGORIES_FAILURE,
    GET_ALL_CATEGORIES_SUCCESS,
    SET_LOADING_CATEGORIES
} from "../Types/CategoryActionTypes";

export interface ICategoriesReducerState {
  categories: IBrandCategory[];
  loadingCategories: boolean;
}

export const categoriesReducerState: ICategoriesReducerState = {
    categories: [],
    loadingCategories: false,
};

export const categoriesReducer = (
    state: ICategoriesReducerState = { ...categoriesReducerState },
    action: CategoryActionType
): ICategoriesReducerState => {
    switch (action.type) {
    /** misc */
        case SET_LOADING_CATEGORIES: {
            return {
                ...state,
                loadingCategories: action.data as boolean,
            };
        }
        /** success */
        case GET_ALL_CATEGORIES_SUCCESS: {
            return {
                ...state,
                categories: action.data as IBrandCategory[],
            };
        }
        /** failure */
        case GET_ALL_CATEGORIES_FAILURE: {
            console.log(action.data);
            return {
                ...state,
            };
        }
        default: {
            return state;
        }
    }
};
